import { adminMarketingQueryKeys as e } from "./adminMarketingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminMarketingApi as n } from "@maat/api-main";
//#region src/marketing/admin/useAdminMarketingAssetsQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.list(r)
});
//#endregion
export { r as useAdminMarketingAssetsQuery };
